module.exports = __webpack_public_path__ + "images/admin/hindsight-listview.png";